import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {ThreadBotStatus} from 'nutshell-graphql-types';
import type {
    GetInboxThreadsByIds as GetInboxThreadsByIdsQuery,
    GetInboxThreadsByIdsVariables as GetInboxThreadsByIdsQueryVariables,
    InboxSidebarThreadFragment,
} from 'nutshell-graphql-types';

import GET_THREADS_BY_IDS from '../queries/get-inbox-threads-by-ids.graphql';

export const useGetInboxThreadsByIds = (
    ids: string[],
    botStatus: ThreadBotStatus
): {
    threads: InboxSidebarThreadFragment[];
    error: string | null | undefined;
    isLoading: boolean;
    refetch: (variables?: GetInboxThreadsByIdsQueryVariables) => Promise<any>;
} => {
    const {
        data,
        error,
        loading: isLoading,
        refetch,
    } = useQuery<GetInboxThreadsByIdsQuery, GetInboxThreadsByIdsQueryVariables>(
        GET_THREADS_BY_IDS,
        {
            skip: ids.length === 0,
            variables: {ids, botStatus},
        }
    );

    const threads: InboxSidebarThreadFragment[] = data?.inboxThreads ?? [];

    return {
        threads,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    };
};
